export class PassagerModel {
  name = "";
  date = "";
  phoneNumber = "";
  clientId = 0;
  note = "";
}
